import { motion } from "framer-motion";
import { CheckCircle2, CalendarDays, Clock, MapPin, Users } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { euDate } from "@/lib/utils";

const L = {
  title: { en: "You're confirmed!", cs: "Vaše rezervace je potvrzena!", he: "ההרשמה שלכם אושרה!", ru: "Ваше участие подтверждено!" },
  desc: { en: "No approval needed — we've saved your spot. Here are your details:", cs: "Bez schvalování — vaše místo je rezervováno. Zde jsou vaše údaje:", he: "אין צורך באישור — שמרנו לכם מקום. הפרטים שלכם:", ru: "Подтверждение не требуется — место за вами. Ваши данные:" },
  guests: { en: "Guests", cs: "Hosté", he: "אורחים", ru: "Гости" },
  emailNote: { en: "A confirmation email is on its way to", cs: "Potvrzení jsme odeslali na", he: "אישור נשלח אל", ru: "Подтверждение отправлено на" },
};

export function RsvpConfirmedCard({ event, rsvp, children }) {
  const { lang, tl } = useLang();
  const tx = (k) => L[k][lang] || L[k].en;
  const parts = (event.parts || []).filter((p) => (rsvp.parts || []).includes(p.id));
  return (
    <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} data-testid="rsvp-confirmed"
      className="rounded-3xl bg-white border border-[#8C9B86]/50 p-8 text-center">
      <span className="mx-auto w-14 h-14 rounded-full bg-[#8C9B86]/15 flex items-center justify-center text-[#6f8069]"><CheckCircle2 size={28} /></span>
      <h3 className="mt-4 font-serif text-2xl">{tx("title")}</h3>
      <p className="mt-2 text-[#475569]">{tx("desc")}</p>
      <div className="mt-5 rounded-2xl bg-[#F9F8F6] p-5 text-start space-y-2 text-sm text-[#0F172A]" data-testid="rsvp-confirmed-details">
        <p className="font-serif text-lg">{tl(event, "title")}</p>
        {event.date && <p className="flex items-center gap-2"><CalendarDays size={15} className="text-[#BE923C]" /> {euDate(event.date)}</p>}
        {event.time && <p className="flex items-center gap-2"><Clock size={15} className="text-[#BE923C]" /> {event.time}</p>}
        {event.location && !event.hide_location && <p className="flex items-center gap-2"><MapPin size={15} className="text-[#BE923C]" /> {event.location}</p>}
        <p className="flex items-center gap-2"><Users size={15} className="text-[#BE923C]" /> {tx("guests")}: {rsvp.guests}</p>
        {parts.length > 0 && (
          <ul className="ms-6 list-disc text-[#475569]">
            {parts.map((p) => <li key={p.id}>{(p.i18n?.[lang]?.label) || p.label}{p.date ? ` · ${euDate(p.date)}` : ""}{p.time ? ` ${p.time}` : ""}</li>)}
          </ul>
        )}
      </div>
      {rsvp.email && <p className="mt-4 text-xs text-[#475569]">{tx("emailNote")} <b>{rsvp.email}</b></p>}
      {children}
    </motion.div>
  );
}
